import Link from 'next/link';
import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const DetailsContent = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px 15px 40px;
  }
`;

export const ModalDescription = styled(Typography.Body).attrs({
  $variant: '4',
})`
  margin-bottom: 25px;
  color: ${({ theme }) => theme.palette.primary.labels};
  white-space: pre-line;
`;

export const PackagesSection = styled.section`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
  }
`;

export const PackagesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 20px;
`;

export const SectionTitle = styled(Typography.Body)`
  font-weight: 500;
`;

export const BusinessLink = styled(Link)`
  flex: 0 0 auto;
  color: ${({ theme }) => theme.palette.system.blue};
  font-size: 15px;
  text-decoration: underline;
`;

export const PackageCards = styled.div`
  display: grid;
  width: 100%;
  min-width: 0;
  grid-auto-columns: minmax(150px, 1fr);
  grid-auto-flow: column;
  gap: 10px;
  overflow-x: auto;
`;

export const PackageCard = styled.article`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 15px 12px 15px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const PackageName = styled(Typography.Body)`
  font-weight: 500;
  margin-bottom: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const PackagePeriods = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PackagePeriod = styled.div`
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const PeriodDays = styled.div`
  margin-bottom: 2px;
  font-size: 14px;
`;

export const OriginalPriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const OriginalPrice = styled.span`
  font-size: 12px;
  text-decoration: line-through;
`;

export const DiscountBadge = styled.span`
  padding: 2px 5px;
  border-radius: 16px;
  background: #f39d16;
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 11px;
  font-weight: 700;
`;

export const PromotionPrice = styled.div`
  margin-top: 2px;
  color: ${({ theme }) => theme.palette.system.blue};
  font-size: 18px;
  font-weight: 700;
`;

export const ConnectButton = styled(Button).attrs({
  appearance: 'secondaryLight',
  borderRadius: 14,
  height: 40,
})`
  margin-top: auto;
`;

export const ContactsSection = styled.section`
  margin-top: 10px;
  padding: 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 20px;
  }
`;

export const ContactsContent = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ContactPeople = styled.div`
  display: flex;
  gap: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const Contact = styled.div`
  font-size: 12px;
`;

export const ContactRole = styled.div`
  margin-bottom: 2px;
`;

export const ContactNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
`;

export const ContactName = styled.span``;

export const ContactLink = styled.a`
  color: inherit;
  text-decoration: none;
`;

export const EmailContacts = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  white-space: nowrap;
`;

export const MailIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const EmailDivider = styled.span`
  width: 1px;
  height: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.labels};
`;
